(function() {
  'use strict';
  angular.module('common')
    .filter('taxParser', function() {
      var allButDigits = /\D+/g;
      return function(val) {
        if (!val) {
          return '';
        }
        val = isNaN(val) ? val.replace(allButDigits,'') : val;
        if (val.length > 9) {
          val = val.substring(0,9);
        }
        var viewValue = val.substring(0,2);
        if (val.length > 2) {
          viewValue = val.substring(0,2) + '-' + val.substring(2,9);
        }
        return viewValue;
      };
    });
})();
